<div mat-dialog-title class="dialog-header">
      <div class="dialog-title">
        <mat-icon class="title-icon">{{ data.icon }}</mat-icon>
        <h2 class="title-text">{{ data.title }}</h2>
      </div>
      <button mat-icon-button class="close-button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="dialog-content">
      <p class="dialog-message">{{ data.message }}</p>

      <mat-form-field *ngIf="data.showInput" class="input-field" appearance="outline">
        <mat-label>{{ data.inputLabel }}</mat-label>
        <input
          matInput
          [(ngModel)]="inputValue"
          [placeholder]="data.inputPlaceholder || ''"
          [required]="data.inputRequired || false"
          type="text">
      </mat-form-field>
       <mat-form-field *ngIf="data.showComment" class="input-field" appearance="outline">
        <mat-label>{{ data.commentsPlaceholder }}</mat-label>
        <textarea
          matInput
          [(ngModel)]="comments"
          [required]=" false"
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
          type="text">
        </textarea>
        <!-- [placeholder]="data.commentsPlaceholder || ''" -->
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
      <button
        mat-button
        (click)="onCancel()"
        class="cancel-btn">
        {{ data.cancelButtonText }}
      </button>
      <button
        mat-raised-button
        (click)="onConfirm()"
        [class.open-btn]="data.title.includes('Open')"
        [class.close-btn]="data.title.includes('Close')"
        class="confirm-btn">
        {{ data.confirmButtonText }}
        <mat-icon>{{data.icon}}</mat-icon>
      </button>
    </mat-dialog-actions>
